var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8V5l3-3 1 2 2 1-3 3zm0 0-4 3.9999M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2m5 10c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget04);
export default __webpack_public_path__ + "static/media/target-04.0c99ca5bfd38542f439cacf85f4a91aa.svg";
export { ForwardRef as ReactComponent };